import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {reserveHistoryRoute} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { TextInput } from '../../components/common/components'
import { setHistoryValue, searchHistory } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'




export default function Search() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveHistoryRoute, (o) => o.path === location.pathname)



    const search = (useSelector(state => state.getIn(["reserveHistory", "search"]))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handlechange = useCallback((field, value) => {        

        dispatch(setHistoryValue({
            page:'search',
            field,
            value
        }))
    }, [dispatch])

    const handleNextClick = () => {       
        dispatch(searchHistory())
    }

    useEffect(() => {
        dispatch(setHistoryValue({
            page:'search',
            field:"PAT_IDNO",
            value:""
        }))
        dispatch(setHistoryValue({
            page:'search',
            field:"TICKET_NO",
            value:""
        }))
        dispatch(setHistoryValue({
            page:'search',
            field:"TEL_MOBILE",
            value:""
        }))
    }, [])

    return <Box className={layoutClasses.page}>        
        <Helmet>
            <title>{reserveHistoryRoute[idx].name}</title>
        </Helmet>
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveHistoryRoute[idx].name}
            </Typography>  
            <TextInput
                label="身分證字號"
                field="PAT_IDNO"
                value={search.PAT_IDNO}
                setValue={handlechange}
            />
            <TextInput
                label="預約代碼"
                field="TICKET_NO"
                value={search.TICKET_NO}
                setValue={handlechange}
            />
            <TextInput
                label="手機號碼"
                field="TEL_MOBILE"
                value={search.TEL_MOBILE}
                setValue={handlechange}
            />
        </Paper>
        {!search.loading?<Button
            variant="contained"
            color="primary"
            style={{ margin: "30px auto" }}
            onClick={() => { handleNextClick() }}
        >
            查詢
        </Button>:null}
    </Box>
}